/**
 * @module Section-Contact-Form
 */

/**
 * 
 * @returns Markup for sample contact form
 */
const SectionContactForm = () => {
    return (
        <div className="cons-contact-form-wrap">
            <div className="comments-area">
                <h3 className="av-large-title mb-4">Contact Us
                </h3>
                <form className="comment-form cons-contact-form" method="post" action="handlers/phpmailer/mail.php">
                    <div className="row">
                        <div className="comment-form-author-1 col-md-6 mb-3">
                            <label><span>Your Name</span></label>
                            <input className="form-control" type="text" name="username" placeholder="Your Name*" id="author" />
                        </div>
                        <div className="comment-form-email-1 col-md-6 mb-3">
                            <label><span>Your Email</span></label>
                            <input className="form-control" type="email" name="email" placeholder="Your Email*" />
                        </div>
                        <div className="comment-form-phone col-md-12 mb-3">
                            <label><span>Phone Number (Optional)</span></label>
                            <input className="form-control" type="tel" name="phone" placeholder="Your Phone Number" />
                        </div>
                        <div className="comment-form-comment-1 col-md-12 mb-4">
                            <label><span>Message</span></label>
                            <textarea className="form-control" rows={8} name="message" placeholder="Message*" id="comment" defaultValue={""} />
                        </div>
                        <div className="comment-form-cookies-consent mb-4">
                            <label className="form-check-label">
                                <input type="checkbox" name="consent" value="1" className="form-check-input me-2" />
                                <span>By submitting your phone number, you consent to receive informational text messages about our services from Anathoth Technologies Limited. Message frequency varies. Message and data rates may apply. You may reply HELP for assistance or STOP to opt out at any time. See our <a href="/privacy-policy">privacy policy</a>.
                                </span>
                            </label>
                        </div>
                        <div className="form-submit">
                            <button type="submit" className="site-button">Send Message <i className="fa fa-send" /></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default SectionContactForm;